import React from 'react';
import "./utilities.css"

class ProgressBar extends React.Component {
    render() {
        return (
            <div className="progress-bar">
                <Filler percentage={this.props.percentage}/>
            </div>
        );
    }
}
  
const Filler = (props) => {
    var percentage = props.percentage > 100 ? 100 : props.percentage
    return <div className="filler" style={{ width: `${percentage}%` }} />
}

export default ProgressBar